import { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";

export const applyMode = (mode) => {
  document.documentElement.dataset.mode = mode === "light" ? "light" : "dark";
};

export const ModeToggle = () => {
  const [mode, setMode] = useState(() => localStorage.getItem("jv-mode") || "light");

  useEffect(() => {
    applyMode(mode);
  }, [mode]);

  const toggle = () => {
    const next = mode === "light" ? "dark" : "light";
    setMode(next);
    localStorage.setItem("jv-mode", next);
    applyMode(next);
  };

  return (
    <button
      onClick={toggle}
      aria-label="Toggle light or dark mode"
      data-testid="mode-toggle-btn"
      className="w-9 h-9 rounded-full border border-hairline flex items-center justify-center text-inkmuted hover:text-gold hover:border-gold/50 transition-colors"
    >
      {mode === "light" ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
};
